module.exports = __webpack_public_path__ + "static/media/Madhav-Photo.6d2471f8.jpg";